import { BrowserCodeReader } from "@zxing/browser";
import { useEffect } from "react";

export const CameraLoader = ({load, onLoaded, onFeatureNotSupported})=>{

    
    const loadCamOptions = async ()=>{
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });
            let devices = await BrowserCodeReader.listVideoInputDevices();
            stream.getTracks().forEach(track => track.stop());
            if (devices.length === 0) {
                onFeatureNotSupported && onFeatureNotSupported();
                return;
            }
            devices = [
                ...devices.filter(d => /back|rear/i.test(d.label)),
                ...devices.filter(d => !/back|rear/i.test(d.label))
            ];
            onLoaded && onLoaded(devices);
        } catch {
            onFeatureNotSupported && onFeatureNotSupported();
        }
        
    };

    useEffect(()=>{
        if(load)
        {
            loadCamOptions();
        }
    }, [load]);

    return null;
};